const BASE_URL = "https://blogify-api-v1.onrender.com/api/v1";
export default BASE_URL;
